const getDefaultState = () => {
  return {
    componentPageConfigure: {
      id: 0,
      path: '',
      templateName: ''
    },
    componentConfigure: {
      id: 0,
      titleid: 0,
      typeid: 0,
      title: '',
      subtitle: ''
    },
    componentDataConfigure: {
      id: 0,
      headline: ''
    }
  }
}

const state = getDefaultState()

const getters = {
  getComponentPageConfigure(state) {
    return state.componentPageConfigure
  },
  getComponentConfigure(state) {
    return state.componentConfigure
  },
  getComponentDataConfigure(state) {
    return state.componentDataConfigure
  }
}

const mutations = {
  RESET_COMPONENT_CONFIGURE: state => {
    Object.assign(state, getDefaultState())
  },
  SET_COMPONENT_PAGE_CONFIGURE: (state, configure) => {
    state.componentPageConfigure = configure
  },
  SET_COMPONENT_CONFIGURE: (state, configure) => {
    state.componentConfigure = configure
  },
  SET_COMPONENT_DATA_CONFIGURE: (state, configure) => {
    state.componentDataConfigure = configure
  }
}

const actions = {
  resetComponentConfigure({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('RESET_COMPONENT_CONFIGURE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
